export default, {
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalWrapper,
  ModalContent,
  FunctionalModal,
  sizes,
} from './Modal';
